import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=2b4311e4&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"
import style0 from "./MenuView.vue?vue&type=style&index=0&id=2b4311e4&prod&scoped=true&lang=css"
import style1 from "./MenuView.vue?vue&type=style&index=1&id=2b4311e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4311e4",
  null
  
)

export default component.exports